<template>
  <a-select
    :options="options"
    v-model.sync="localValue"
    btn-color="clear-area"
    :has-teleport="!outsideModal"
    :missing-option-error-message="missingOptionErrorMessage"
  >
  </a-select>
</template>

<script lang="ts">
  import Vue from "vue";
  import {IVOptionSetLocal} from "../../../interfaces/vSelectInterfaces";
  import LocalValueEmissionMixin from "../../../mixins/localValueEmissionMixin";
  import IConditionalRuleReferencedControl from "../../../models/conditionalRules/referencedControl";
  import IConditionalRuleContainer from "../../../models/conditionalRules/conditionalRuleContainer";
  import {StringHelper} from "~/helpers/stringHelper";

  export default Vue.extend({
    props: {
      value: {},
      type: {},
      parent: Object as () => IConditionalRuleContainer,
      includeBuiltInProperties:{
        type: Boolean,
        default: false,
      },
      includePaymentStepBuiltInProperties: {
        type: Boolean, 
        default: false,
      },
      outsideModal: {
        type: Boolean,
        default: false,
      },
    },
    mixins: [LocalValueEmissionMixin],
    data() {
      return {
      };
    },
    computed: {
      builtInPropertiesOptions(): IVOptionSetLocal {
        return this.parent.conditionalRulesBuiltInValueOptions
      },
      paymentStepBuiltInPropertiesOptions(): IVOptionSetLocal {
        return this.parent.conditionalRulesPaymentStepBuiltInValueOptions
      },
      options(): IVOptionSetLocal[] {
        const options: IVOptionSetLocal[] = [];
        if (typeof this.parent.getGroupedReferencableControls === 'function') {
          const groups: {[key: string]: IConditionalRuleReferencedControl[]} = this.parent.getGroupedReferencableControls();
          for (const [group, controls] of Object.entries(groups)) {
            options.push({
              valueKey: 'client_id',
              labelKey: 'referenceNameOrDefault',
              heading: group,
              options: controls,
            });
          }
        } else {
          options.push({
            valueKey: 'client_id',
            labelKey: 'referenceNameOrDefault',
            options: this.parent.getReferencableControls(),
          });
        }
        if (this.includeBuiltInProperties) {
          options.push(this.builtInPropertiesOptions);
        }
        if (this.includePaymentStepBuiltInProperties) {
          options.push(this.paymentStepBuiltInPropertiesOptions)
        }
        return options;
      },
      missingSelectedOption(): boolean {
        return this.localValue && !this.options.find(set => !!set.options.find(o => o[set.valueKey] === this.localValue));
      },
      missingOptionErrorMessage(): string {
        if (this.missingSelectedOption) {
          return StringHelper.capitalize(`${this.friendlyReferencableControlsName} no longer exists`);
        }
      },
      friendlyReferencableControlsName(): string {
        if (!this.parent.friendlyReferencableControlsName) console.error(`parent missing friendlyReferencableControlsName! Please implement for ${this.parent}`);

        return this.parent.friendlyReferencableControlsName;
      },
    }
  });
</script>